import { useCallback, useEffect, useState } from "react";
import api from "@/lib/api";

export function useLegalAdmin(pageId) {
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);
  const load = useCallback(() => {
    setError(false);
    api.get("/admin/legal", { params: pageId ? { page_id: pageId } : {} })
      .then((r) => setData(r.data))
      .catch(() => setError(true));
  }, [pageId]);
  useEffect(() => { load(); }, [load]);
  return { data, error, reload: load };
}

export const errText = (e, fallback) => {
  const d = e?.response?.data?.detail;
  return typeof d === "string" ? d : fallback;
};
